import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { COLOR_TYPE_OFFLINE } from "../../../../utils/constants";
import { setUserOnlineStatus } from "../../../../state/actions/user";


const SlowNetworkBanner = ({ closeSlowInternetBanner }) => {
    const selectedDomain = useSelector((state) => state.domain.selectedDomain);
    const dispatch = useDispatch();


    const handleChange = (event) => {
        dispatch(setUserOnlineStatus(event.target.checked));
        closeSlowInternetBanner();
    };

    const isThurayaDomain = [
        "Thuraya Test",
        "T2M",
        "T2M Test",
        "THURAYA",
        "THURAYA TRACKER",
    ].includes(selectedDomain);

    return (
        <div
            className="px-2.5 py-0.5 font-semibold text-[#696969]"
            style={{ backgroundColor: COLOR_TYPE_OFFLINE }}
        >
            {!isThurayaDomain ? (
                <span className="px-2.5">
                    You are working on a slow connection, would you like to set yourself offline?{" "}
                    <u
                        onClick={handleChange}
                        className="cursor-pointer"
                    >
                        Set Offline
                    </u>
                </span>
            ) : (
                <span className="px-2.5">
                    You are working on a slow connection.
                </span>
            )}
        </div>
    );
};

export default SlowNetworkBanner;
